import * as React from "react";
import type { ListItemProps } from "../../views/list-item/list-item-view";
import ListItemView from "../../views/list-item/list-item-view";
import type { Subtract } from "utility-types";
import { hasFlag } from "webapp/lib/has-flag";
import { ListItemFlags } from "common/generator/array-screens/list-item-flags";

interface Handled {
    readonly touched?: boolean;
    readonly showActionBubble?: boolean;

    readonly onTouchChanged?: (touched: boolean) => void;
    readonly onLongPressChanged?: (pressed: boolean) => void;
}

type Props = Subtract<ListItemProps, Handled>;

const ListItem: React.FunctionComponent<Props> = (props: Props) => {
    const { onClick, flags, ...rest } = props;
    const [touched, setTouched] = React.useState<boolean>(false);
    const [showBubble, setShowBubble] = React.useState<boolean>(false);
    const [clickable, setClickable] = React.useState<boolean>(false);

    const onTouchChanged = React.useCallback((newVal: boolean) => {
        setTouched(newVal);
    }, []);
    const onLongPressChanged = React.useCallback(
        (newVal: boolean) => {
            if (hasFlag(flags, ListItemFlags.DisableLongPress)) return;
            setShowBubble(newVal);
        },
        [flags]
    );
    const onClickCallback = React.useCallback(
        (handled: boolean) => {
            if (onClick !== undefined) {
                onClick(handled);
            }
        },
        [onClick]
    );

    React.useEffect(() => {
        setClickable(onClick !== undefined);
    }, [onClick]);

    return (
        <ListItemView
            {...rest}
            flags={flags}
            touched={touched}
            showActionBubble={showBubble}
            onTouchChanged={onTouchChanged}
            onLongPressChanged={onLongPressChanged}
            onClick={onClickCallback}
            clickable={clickable}
        />
    );
};

export default ListItem;
